import { defineStore } from 'pinia';
import pjson from '~/package.json';
import type { EnvironmentInfo, PageInfo } from '~/types/dataLayer';

export const useDataLayerStore = defineStore('dataLayer', () => {
  const environmentInfo = ref({} as EnvironmentInfo);
  const pageInfo = ref({} as PageInfo);

  const view = useRoute()?.query?.view || '';

  function setEnvironmentInfo () {
    environmentInfo.value = {
      env: import.meta.env.APP_ENV || import.meta.env.NODE_ENV || '',
      version: pjson.version || '',
      platform: 'cpp',
      view: view === 'noheader' || view === 'ZW1iZWQ' || view === 'app' ? 'app' : 'web'
    };
  }
  function setPageInfo (value: PageInfo) {
    pageInfo.value = value;
  }

  return {
    environmentInfo,
    pageInfo,
    setEnvironmentInfo,
    setPageInfo
  };
});
